class DiccionarioReadDto {
  public id: number;
  public title: string;
  public description: string;
  public category: string;
}

export default DiccionarioReadDto;
